<template>
  <el-row>
    <el-col>
      <div class="top">
         <!-- <a target="_bank" href="#"><img src="http://yhapp.iceo.com.cn/static/front/img/2026-wzqh.jpg" alt="顶部广告" class="top-img"></a> -->
         <!-- <a target="_bank" href="http://www.iceo.com.cn/zt/2022_xyesd/xyesd.shtml"><img src="http://swapp.iceo.com.cn/Public/images/newsite/2022-fenjin20.jpg" alt="顶部广告" class="top-img"></a> -->
        <!-- <a target="_bank" href="https://www.iceo.com.cn/zt/2025_lh/2025lh.shtml"><img src="https://swapp.iceo.com.cn/Public/images/2025-lhbanner.jpg" alt="顶部广告" class="top-img"></a> -->
        <!-- <a target="_bank" href="https://www.iceo.com.cn/zt/2025_lh/2025lh.shtml"><img src="https://swapp.iceo.com.cn/Public/images/2025-lhbanner.jpg" alt="顶部广告" class="top-img"></a> -->
        <span v-for="(vals,index) in topArtical" :key="index">
          <h1  v-if="index <= 0"><a class="red_topic" :href="vals.url + vals._uniquecode" target="_blank" v-html="vals.theme"></a></h1>
          <p v-if="index > 0">
            <span><a :class="{ 'title_small': hasSmalltitle }" :href="vals.url + vals._uniquecode" target="_blank" v-html="vals.theme">成立104年，执政75年，中国共产党带领人民矢志不渝、笃行不怠，创造了彪炳史册的辉煌业绩，书写了气壮山河的恢宏史诗</a></span>
          </p>
        </span>
       
      </div>
    </el-col>
  </el-row>

</template>
<script>

  export default {
    name: 'Top',
    data() {
      return {
        msg: 'success',
        topArtical:[],
        hasSmalltitle: true
      }
    },
    created(){
      this.fetch_hotArticle()
    },
    methods:{
      fetch_hotArticle(){
        var config = {
          method: 'GET',
          url: '/api/v1/artical/hot/list',
          headers: { 
            'Content-Type': 'application/json'
          }
        };
            
        this.$axios(config).then(res=>{
          this.topArtical = res.data.data
        }).catch(error=>{
          console.log('请求失败')
        })

      }
    }
  }
</script>
<style scoped>
  >>>.red_topic{
    color: rgb(221,0,15);
  }
  .title_small{
   /** color: #bd0c16 !important; */
   color: #000000 !important; 

  } 
  .top {
    width: 1200px;
    margin: 0px auto 40px;
    text-align: center;
  }

  .top-img {
    width: 100%;
    display: block
  }

  .top span h1 {
    display: block;
    margin: 0 auto 6px;
    padding-top: 40px;
    color:#bd0c16 !important;
    margin-bottom:10px;
  }
  .top span h1 a{
    /** color:#bd0c16 !important; */
    /** color:#000000 !important;*/
    color: rgb(221,0,15);
  }

  .top h1 a {
    font-family: Helvetica,Arial,'Microsoft YaHei','微软雅黑',STHeitiSC-Light,simsun,'宋体','WenQuanYi Zen Hei','WenQuanYi Micro Hei',sans-serif;
    font-size: 30px;
    font-weight: bold;
    color: #000;
    text-decoration: none;
    color: #000000
  }
  .top p{
      margin: 0 15px;
      line-height: 22px;
      display: inline;

  }
  .top p span {
    margin: 0 10px;
    color: #999;
    font-size: 15px;
  }

  .top p a {
    color: #999;
    text-decoration: none
  }
 </style>



// WEBPACK FOOTER //
// src/components/public/top.vue